import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { GenericDetailPage, ProjectInfoBox, Spinner } from '@repo/components';
import { useAuthenticatedUser } from 'src/hooks/useAuthenticatedUser';
import { getCompanyProject } from 'src/api/company';
import { useBreadcrumbLevel } from '@repo/components/hooks';

export const Route = createFileRoute('/company_/$groupId/projects/$projectId')({
	component: RouteComponent,
});

function RouteComponent() {
	const { groupId, projectId } = Route.useParams();
	const { user: authenticatedUser, loading: userLoading } = useAuthenticatedUser();

	const { data: project, isLoading: projectLoading } = useQuery({
		queryKey: ['company-project', groupId, projectId],
		queryFn: () => getCompanyProject(groupId, projectId),
		enabled: !userLoading,
	});

	useBreadcrumbLevel(1, 'Projects', `/company/${groupId}/projects`);
	useBreadcrumbLevel(2, project?.name || 'Project Details');

	if (userLoading || projectLoading) {
		return <Spinner className="text-[#1E1E1E]" />;
	}

	if (!authenticatedUser || !project) return null;

	return (
		<GenericDetailPage>
			<GenericDetailPage.Content>
				<ProjectInfoBox
					project={project}
					permissions={{
						canEdit: false,
						canArchive: false,
					}}
				/>
			</GenericDetailPage.Content>
			<Outlet />
		</GenericDetailPage>
	);
}
